var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ccc;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.74,53.8l-16.01-16.01,3.07-3.07,12.94,12.94,27.45-27.45,3.07,3.07-30.53,30.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep50);
export default __webpack_public_path__ + "static/media/step-5-0.8ccaeb10aaadfda815799ea258ba7369.svg";
export { ForwardRef as ReactComponent };